module.exports = __webpack_public_path__ + "img/16.de5dccc1.png";